
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { TranslationProvider } from '@/context/translation';
import { createNonLocalizedPageGetServerSidePropsWithTranslations, type NonLocalizedPageWithTranslationsProps, } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const BeautyProductsLanding = dynamic(async () => await import('@/templates/Landing/BeautyProducts/BeautyProductsLanding'), {
    loading: LoaderScreen,
});
const index: React.FC<NonLocalizedPageWithTranslationsProps> = ({ locale, translations, }) => {
    return (<TranslationProvider locale={locale} translations={translations}>
			<LandingLayout title='AI-Powered Beauty Product Photography for E-Commerce | Lift' description='Lift helps beauty brands and e-commerce sellers create stunning, market-ready product images without expensive photoshoots. Highlight textures, polish visuals, and boost your brand’s presence with AI-powered photography tools.' ogTitle="Create Stunning Beauty Product Images Instantly with Lift's AI" ogDescription='With Lift’s AI tools, generate flawless beauty product photos in minutes. Remove backgrounds, enhance visuals, and maintain brand consistency to drive more sales and engagement.'>
				<BeautyProductsLanding />
			</LandingLayout>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSidePropsWithTranslations('/for-businesses/beauty-product-photography', 'beauty-product-photography');

    async function __Next_Translate__getServerSideProps__1a1a20bb8b5__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/beauty-product-photography/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8b5__ as getServerSideProps }
  